import React, { memo } from 'react';
import { Nav } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { MEDWIKI_NAME } from '../../../common/common';
import {
  ChannelLogo,
  ClinicalVideoLogo,
  FaRegUser,
  Grlogo,
  LiveCmeLogo,
  MedwikiLogo,
  SpqLogo,
  TrainingLogo
} from '../../../components/icons';

const TabNav = ({ type_array, search_results, key }) => {
  const filterResultArray = (type) => {
    if (search_results?.some((r) => r.trending_type == type || r.type == type)) {
      return search_results?.filter((r) => r.trending_type == type || r.type == type);
    } else {
      return [];
    }
  };
  const Logo = ({ type }) => {
    switch (type) {
      case 'comp':
        return <MedwikiLogo className={'fs-1 text-black'} />;
      case 'video_archive':
        return <ClinicalVideoLogo className={'fs-1 text-black'} />;
      case 'session':
        return <LiveCmeLogo className={'fs-1 text-black'} />;
      case 'gr':
        return <Grlogo className={'fs-1 text-black'} />;
      case 'survey':
        return <SpqLogo className={'fs-1 text-black'} />;
      case 'training':
        return <TrainingLogo className={'fs-1 text-black'} />;
      case 'profile_doctor':
        return <FaRegUser customClass={'fs-1 text-black'} />;
      case 'channel':
        return <ChannelLogo className={'fs-1 text-black'} />;

      default:
        return <></>;
    }
  };
  const typeName = (type) => {
    switch (type) {
      case 'comp':
        return MEDWIKI_NAME;
      case 'video_archive':
        return 'Clinical Video';
      case 'session':
        return 'Live CME';
      case 'gr':
        return 'Grand Round';
      case 'survey':
        return 'Polls & Quizzes';
      case 'training':
        return 'Certified Courses';
      case 'profile_doctor':
        return 'Speakers';
      case 'channel':
        return 'Channels';

      default:
        return '';
    }
  };
  const TabTitleComponent = ({ eventKey }) => {
    let data = eventKey == 'all' ? search_results : filterResultArray(eventKey);
    console.log('hui', data);
    let count = data?.length > 0 ? data?.length : 0;
    return (
      <Nav.Item className="cursorPointer">
        <Nav.Link
          eventKey={eventKey}
          className="rounded-3 bg-white border border-light p-3 p-lg-3 px-lg-4 text-black fs-16 fw-medium gtm_cl_searchresult_tabTitle_box"
        >
          <div className="d-flex align-items-center searchresult_tabTitle_section">
            <div className="searchTabIcon rounded-circle text-black fs-4 fw-medium d-flex justify-content-center align-items-center bg-light me-3 searchresult_tabTitle_logoSection">
              {eventKey == 'all' ? 'All' : <Logo type={eventKey} />}
            </div>
            <div className="searchTabDetails text-start flex-1">
              <span className="fs-16 fw-medium text-black text-capitalize text-start searchresult_tabTitle_count">
                {count}
                <span className="d-block fs-4 searchresult_tabTitle_serviceNames">
                  {eventKey == 'all' ? 'Search Results' : typeName(eventKey)}
                </span>
              </span>
            </div>
          </div>
        </Nav.Link>
      </Nav.Item>
    );
  };
  return (
    <Nav variant="pills">
      <Swiper
        className="searchTabSwiper ms-0 pb-1"
        spaceBetween={7}
        slidesPerView={'auto'}
        loop={false}
        freeMode="true"
        mousewheel={true}
        breakpoints={{
          1: {
            spaceBetween: 5
          },
          768: {
            spaceBetween: 8
          }
        }}
      >
        {type_array?.map((_type) => {
          let data = _type == 'all' ? search_results : filterResultArray(_type);
          let count = data?.length > 0 ? data?.length : 0;
          console.log('huiiiiiiiiiii', _type);
          return count > 0 ? (
            <SwiperSlide className="searchTabSlide w-auto">
              <TabTitleComponent eventKey={_type} />
            </SwiperSlide>
          ) : null;
        })}
      </Swiper>
    </Nav>
  );
};

export default memo(TabNav);
